import { toast } from "react-toastify"
import { CHECK_ACCOUNT_URI, CHECK_COOKIE_URI, GET_PLAYER_SETTING_URI, LOGIN_TOKEN_INFO_URI, POST_PLAYER_SETTING_URI, POST_SELL_EQUIPMENT_URI, POST_START_AUTO_TRUC_LOC_URI, POST_START_FARM_HAI_SAN_URI, POST_START_QUOC_CHIEN_URI, POST_STOP_AUTO_TRUC_LOC_URI, POST_STOP_SELL_EQUIPMENT_URI, START_GAME_URI, STOP_GAME_URI, TOKEN_INFO_URI } from "../constants/api"
import { LIMIT_COUNT_TRUC_LOC_COMBAT, LIMIT_LEVEL_TRUC_LOC, PLAYER_CONFIG, TIME_EVENT_TRUC_LOC } from "../constants/Common"
import { STORAGE_KEY } from "../constants/storageKeys"
import { get, post } from "../utils/helpers"
import { getLocalStorage, removeLocalStorage, setLocalStorage } from "../utils/localStorage"
import { CODE_EXPIRED, DONE_GET_SETTING, DONE_UPDATE_SETTING, ERROR_GET_SETTING, ERROR_START_SELL_EQUIPMENT, ERROR_START_TRUC_LOC, ERROR_STOP_PLAYER, ERROR_TRUC_LOC_LIMIT_LEVEL, ERROR_TRUC_LOC_LIMIT_TIME, ERROR_UPDATE_SETTING, ERROT_GET_COOKIE, GETTED_COOKIE, GETTING_COOKIE, GETTING_SETTING, NO_SELL_EQUIPMENT, NO_UPDATE_SETTING, START_AUTO_TRUC_LOC, START_SELL_EQUIPMENT, STOPPED_PLAYER, STOPPING_PLAYER, UPDATING_SETTING } from "../constants/errMessage"
import { TOAST_TYPE, updateToastPromise } from "../contexts/ToastProvider"
import playerInfoStore from "../store/playerInfos"
import playerConfigStore from "../store/playerConfigs"
import onlineInfoStore from "../store/onlineInfo"

// export const loginTokenAuth = async () => {
//     return await get(TOKEN_INFO_URI);
// }

export const loginTokenAuth = async () => {
    //console.log('loginTokenAuth')
    const ret = await post(LOGIN_TOKEN_INFO_URI)
    if (ret.error) {
        removeLocalStorage(STORAGE_KEY.TOKEN)
    } else {
        setLocalStorage(STORAGE_KEY.TOKEN, ret.data);
    }
    return ret;
}

export const checkCookie = async (cookie) => {
    //console.log('checkCookie');
    const _cookie = cookie;
    if (_cookie == null) {
        return false
    }
    const payload = { cookie: _cookie };
    try {
        const ret = await post(CHECK_COOKIE_URI, payload);
        if (ret.error == false) {
            setLocalStorage(STORAGE_KEY.COOKIE_INFO, ret?.data?.cookieInfo);

            const players = ret?.data?.players.reduce((acc, player) => {
                acc[player.PlayerId] = player;
                return acc;
            }, {});
            setLocalStorage(STORAGE_KEY.PLAYER_INFO, players);

            setLocalStorage(STORAGE_KEY.USER_INFO, ret?.data?.userInfo);

            const servers = ret?.data?.servers.reduce((acc, server) => {
                acc[server.Id] = server;
                return acc;
            }, {});
            setLocalStorage(STORAGE_KEY.SERVER_INFO, servers);
            return true
        } else if (ret.status == 401) {
            removeLocalStorage(STORAGE_KEY.LOGIN_TOKEN);
            return -1
        } else {
            removeLocalStorage(STORAGE_KEY.COOKIE_INFO);
            removeLocalStorage(STORAGE_KEY.PLAYER_INFO);
            removeLocalStorage(STORAGE_KEY.USER_INFO);
            removeLocalStorage(STORAGE_KEY.SERVER_INFO);
            return -2
        }
    } catch (error) {
        removeLocalStorage(STORAGE_KEY.COOKIE_INFO);
        removeLocalStorage(STORAGE_KEY.PLAYER_INFO);
        removeLocalStorage(STORAGE_KEY.USER_INFO);
        removeLocalStorage(STORAGE_KEY.SERVER_INFO);
        return false
    }

}

export const checkAccount = async (username, password) => {
    //console.log('checkAccount');
    if (username == null || password == null) {
        return false
    }
    const payload = {
        UserName: username,
        Password: password
    };

    const toastId = toast.loading(GETTING_COOKIE);
    try {
        const ret = await post(CHECK_ACCOUNT_URI, payload);
        if (ret.error == false) {
            removeLocalStorage(STORAGE_KEY.COOKIE_INFO);
            removeLocalStorage(STORAGE_KEY.PLAYER_INFO);
            removeLocalStorage(STORAGE_KEY.USER_INFO);
            removeLocalStorage(STORAGE_KEY.SERVER_INFO);
            setLocalStorage(STORAGE_KEY.COOKIE_INFO, ret.data.cookieInfo);
            const players = ret?.data?.players.reduce((acc, player) => {
                acc[player.PlayerId] = player;
                return acc;
            }, {});
            setLocalStorage(STORAGE_KEY.PLAYER_INFO, players);
            const _userInfo = ret?.data?.userInfo;
            _userInfo.password = password;
            setLocalStorage(STORAGE_KEY.USER_INFO, _userInfo);

            const servers = ret?.data?.servers.reduce((acc, server) => {
                acc[server.Id] = server;
                return acc;
            }, {});
            setLocalStorage(STORAGE_KEY.SERVER_INFO, servers);
            updateToastPromise(toastId, GETTED_COOKIE, TOAST_TYPE.SUCCESS)
            return true
        } else if (ret.status == 401) {
            updateToastPromise(toastId, CODE_EXPIRED, TOAST_TYPE.ERROR)
            removeLocalStorage(STORAGE_KEY.LOGIN_TOKEN);
            return -1
        } else {
            updateToastPromise(toastId, ERROT_GET_COOKIE, TOAST_TYPE.ERROR)
            removeLocalStorage(STORAGE_KEY.COOKIE_INFO);
            removeLocalStorage(STORAGE_KEY.PLAYER_INFO);
            removeLocalStorage(STORAGE_KEY.USER_INFO);
            return -2
        }

    } catch (error) {
        updateToastPromise(toastId, ERROT_GET_COOKIE, TOAST_TYPE.ERROR)
        removeLocalStorage(STORAGE_KEY.COOKIE_INFO);
        removeLocalStorage(STORAGE_KEY.PLAYER_INFO);
        removeLocalStorage(STORAGE_KEY.USER_INFO);
        return -3
    }

}

export const getPlayersbyToken = async () => {
    //console.log('getPlayersbyToken')
    return await get(TOKEN_INFO_URI);
}

/**
 * 
 * @param {*} payload
 * {
 * user: {token, userId, userName}
 * player: {country, level, playerId, name}
 * server: {id, name, shortName, port}
 * } 
 * @returns 
 */
export const startGame = async (payload) => {
    try {
        const res = await post(START_GAME_URI, payload);
        if (res.error === false) {
            return res
        }
        onlineInfoStore.getState().setOnline(payload.player?.playerId, false)
        return res
    } catch (error) {
        onlineInfoStore.getState().setOnline(payload.player?.playerId, false)
        return { error: true }
    }
}

export const stopGame = async (playerId) => {
    //console.log('stop game');
    const toastId = toast.loading(STOPPING_PLAYER);
    try {
        const res = await post(STOP_GAME_URI, { playerId: playerId });
        if (res.error === false) {
            updateToastPromise(toastId, STOPPED_PLAYER, TOAST_TYPE.SUCCESS)
            onlineInfoStore.getState().setOnline(playerId, false)
            return res
        }
        updateToastPromise(toastId, ERROR_STOP_PLAYER, TOAST_TYPE.ERROR)
    } catch (error) {
        updateToastPromise(toastId, ERROR_STOP_PLAYER, TOAST_TYPE.ERROR)
        return { error: true }
    }
}

export const startFarmSeaFood = async (playerId, playerName) => {
    //console.log('startFarmSeadFood');
    const payload = {
        player: {
            playerId: playerId,
            name: playerName
        }
    }
    return await post(POST_START_FARM_HAI_SAN_URI, payload)
}

export const startTrucLoc = async (playerId, count) => {
    //console.log('startTrucLoc');
    const toastId = toast.info(START_AUTO_TRUC_LOC);
    const playerInfo = playerInfoStore.getState().playerInfos[playerId];
    if (playerInfo == null || count == null) {
        updateToastPromise(toastId, ERROR_START_TRUC_LOC, TOAST_TYPE.ERROR);
        return { error: true }
    }
    if (playerInfo.Level < LIMIT_LEVEL_TRUC_LOC) {
        updateToastPromise(toastId, `${ERROR_TRUC_LOC_LIMIT_LEVEL}${LIMIT_LEVEL_TRUC_LOC}`)
        return { error: true }
    }
    const now = new Date();
    // Lấy thời gian hiện tại theo múi giờ +07:00
    const nowTime = now.toLocaleTimeString('en-GB', { hour12: false, timeZone: 'Asia/Bangkok' });

    // Lấy thời gian bắt đầu & kết thúc sự kiện
    const startTime = TIME_EVENT_TRUC_LOC.START_TIME.split('+')[0]; // '19:30:00'
    const endTime = TIME_EVENT_TRUC_LOC.END_TIME.split('+')[0];     // '20:00:00'
    // console.log('_isInTimeTrucLoc', now, startTime, endTime)
    if (nowTime < startTime || nowTime > endTime) {
        updateToastPromise(toastId, ERROR_TRUC_LOC_LIMIT_TIME)
        return { error: true }
    }
    const _count = count > LIMIT_COUNT_TRUC_LOC_COMBAT ? LIMIT_COUNT_TRUC_LOC_COMBAT : count
    const payload = {
        player: {
            playerId: playerId,
            name: playerInfo.Name
        },
        count: _count
    }
    try {
        const res = await post(POST_START_AUTO_TRUC_LOC_URI, payload)
        if (res.error === false) {
            updateToastPromise(toastId, START_AUTO_TRUC_LOC, TOAST_TYPE.SUCCESS);
        }
        else updateToastPromise(toastId, ERROR_START_TRUC_LOC, TOAST_TYPE.ERROR)
        return res
    } catch (error) {
        updateToastPromise(toastId, ERROR_START_TRUC_LOC, TOAST_TYPE.ERROR)
        return error
    }
}

export const postStopTrucLoc = async (playerId) => {
    const playerInfo = playerInfoStore.getState().playerInfos[playerId];
    if (playerInfo == null) {
        return { error: true }
    }
    const payload = {
        player: {
            playerId: playerId,
            name: playerInfo.Name
        }
    }
    try {
        const res = await post(POST_STOP_AUTO_TRUC_LOC_URI, payload);
        return res
    } catch (error) {
        return error
    }
}

export const postStopSellEquipments = async (playerId) => {
    const playerInfo = playerInfoStore.getState().playerInfos[playerId];
    if (playerInfo == null) {
        return { error: true }
    }
    const payload = {
        player: {
            playerId: playerId,
            name: playerInfo.Name
        }
    }
    try {
        const res = await post(POST_STOP_SELL_EQUIPMENT_URI, payload);
        return res
    } catch (error) {
        return error
    }
}

export const postSellEquipments = async (playerId, sellEquipments) => {
    const toastId = toast.info(START_SELL_EQUIPMENT);
    const playerInfo = playerInfoStore.getState().playerInfos[playerId];
    if (playerInfo == null || sellEquipments == null) {
        updateToastPromise(toastId, ERROR_START_SELL_EQUIPMENT, TOAST_TYPE.ERROR);
        return { error: true }
    }
    if ((sellEquipments instanceof Array) && sellEquipments.length > 0) {
        const payload = {
            player: {
                playerId: playerId,
                name: playerInfo.Name
            },
            sellEquipments: sellEquipments
        }
        try {
            const res = await post(POST_SELL_EQUIPMENT_URI, payload);
            if (res.error === false) {
            }
            else updateToastPromise(toastId, ERROR_START_SELL_EQUIPMENT, TOAST_TYPE.ERROR)
            return res
        } catch (error) {
            updateToastPromise(toastId, ERROR_START_SELL_EQUIPMENT, TOAST_TYPE.ERROR)
            return error
        }
    } else {
        updateToastPromise(toastId, NO_SELL_EQUIPMENT, TOAST_TYPE.SUCCESS);
        return { error: true }
    }
}

export const getConfigPlayer = async (playerId) => {
    const toastId = toast.loading(GETTING_SETTING);
    const playerInfo = playerInfoStore.getState().playerInfos[playerId];
    if (playerInfo == null) {
        updateToastPromise(toastId, ERROR_GET_SETTING, TOAST_TYPE.ERROR);
        return { error: true }
    }
    const payload = {
        player: {
            playerId: playerId,
            name: playerInfo.Name
        }
    }
    try {
        const res = await post(GET_PLAYER_SETTING_URI, payload);
        if (res.error === false) {
            updateToastPromise(toastId, DONE_GET_SETTING, TOAST_TYPE.SUCCESS)
            return res
        }
        else updateToastPromise(toastId, ERROR_GET_SETTING, TOAST_TYPE.ERROR)
        return res
    } catch (error) {
        updateToastPromise(toastId, ERROR_GET_SETTING, TOAST_TYPE.ERROR);
        return { error: true }
    }

}
export const startQuocChien = async (playerId, playerName) => {
    const payload = {
        player: {
            playerId: playerId,
            name: playerName
        }
    }
    return await post(POST_START_QUOC_CHIEN_URI, payload)
}

export const configPlayer = async (playerId, newConfig) => {
    //console.log('configPlayer');
    const toastId = toast.loading(UPDATING_SETTING);
    const playerInfo = playerInfoStore.getState().playerInfos[playerId];
    const configs = playerConfigStore.getState().playerConfigs[playerId];

    if (playerInfo == null || configs == null) {
        updateToastPromise(toastId, ERROR_UPDATE_SETTING, TOAST_TYPE.ERROR);
        return { error: true }
    }
    const _config = {}
    for (const id in newConfig) {
        // console.log('configPlayer 2', id, newConfig[id], configs[id])
        if (id == PLAYER_CONFIG.ID_PRIORITY_HAI_SAN
            || id == PLAYER_CONFIG.ID_OBJECT_LEGION_DROP_ITEM
        ) {
            const oldstr = configs[id].join(',');
            const newstr = newConfig[id].join(',');
            if (oldstr !== newstr) _config[id] = [...newConfig[id]]
        }
        else if (configs[id] != null && configs[id] != newConfig[id]) {
            _config[id] = newConfig[id]
            // console.log('configPlayer 3', _config[id], newConfig[id])
        }
    }


    if (Object.keys(_config).length > 0) {
        const payload = {
            player: {
                playerId: playerId,
                name: playerInfo.Name
            },
            config: _config
        }
        //auto login
        if (_config[PLAYER_CONFIG.ID_AUTO_START_GAME] == 1) {
            const userInfo = getLocalStorage(STORAGE_KEY.USER_INFO);
            if (userInfo?.password != null) payload.player.token = userInfo.password
        }
        try {
            // console.log('configPlayer 4', payload)
            const res = await post(POST_PLAYER_SETTING_URI, payload);
            if (res.error === false) {
                for (const id in res.data) {
                    if (id == PLAYER_CONFIG.ID_PRIORITY_HAI_SAN
                        || id == PLAYER_CONFIG.ID_OBJECT_LEGION_DROP_ITEM
                    ) {
                        playerConfigStore.getState().updateSingleConfig(playerId, id, [...res.data[id]])
                    }
                    else playerConfigStore.getState().updateSingleConfig(playerId, id, Number(res.data[id]))
                }
                updateToastPromise(toastId, DONE_UPDATE_SETTING, TOAST_TYPE.SUCCESS)
            }
            else updateToastPromise(toastId, ERROR_UPDATE_SETTING, TOAST_TYPE.ERROR)
            return res
        } catch (error) {
            updateToastPromise(toastId, ERROR_UPDATE_SETTING, TOAST_TYPE.ERROR)
            return error
        }
    }
    updateToastPromise(toastId, NO_UPDATE_SETTING, TOAST_TYPE.SUCCESS);
    return { error: false }
}
